import { StyleSheet } from 'react-native';

import { Fonts, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  outerViewStyle: isVerticalLayout => {
    return {
      alignItems: 'center',
      flex: 1,
      marginTop: isVerticalLayout ? Metrics.doubleBaseMargin : Metrics.baseMargin,
    };
  },
  errorDetailsViewStyle: isVerticalLayout => {
    return {
      flex: 3,
      flexDirection: isVerticalLayout ? 'column' : 'row',
      justifyContent: isVerticalLayout ? 'space-around' : 'center',
      alignItems: 'center',
    };
  },
  errorDetailsImageStyle: isVerticalLayout => {
    return {
      width: isVerticalLayout ? 40 : 25,
      height: isVerticalLayout ? 40 : 25,
      marginRight: isVerticalLayout ? 0 : 7,
    };
  },
  errorDetailsTextStyle: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: 17,
    color: theme.colors.sectionItemTextColor,
  }),
  errorActionViewStyle: {
    flex: 2,
  },
  errorActionClickStyle: isHorizontalLayout => {
    return {
      marginLeft: isHorizontalLayout ? 17 : 0,
      flexDirection: 'row',
      alignItems: 'center',
    };
  },
  errorActionImageStyle: isVerticalLayout => {
    return {
      width: isVerticalLayout ? 26 : 21,
      height: isVerticalLayout ? 26 : 21,
      marginLeft: 4,
    };
  },
  errorActionTextStyle: theme => ({
    textAlign: 'center',
    fontFamily: Fonts.type.VFFont,
    fontSize: 15,
    color: theme.colors.tryAgainColor,
  }),
});
